var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "login", attrs: { id: "page" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6", "offset-md": "3" } }, [
                _c(
                  "div",
                  { staticClass: "login-panel" },
                  [
                    _c(
                      "div",
                      { staticClass: "login-logo" },
                      [
                        _c(
                          "b-link",
                          { attrs: { to: { name: "home" } } },
                          [_c("logo", { attrs: { size: "sm" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("auth-login-form"),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "login-forgot" },
                      [
                        _c(
                          "b-link",
                          { attrs: { to: { name: "forgot-password" } } },
                          [_vm._v("Forgot password?")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "login-footer-actions" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "outline-primary",
                              size: "sm",
                              href: _vm.applyUrl,
                            },
                          },
                          [_vm._v("Apply for Membership")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }